window.addEventListener('load', function () {
	var sec = document.getElementById('side_button');
	if (!sec) return;
	var btn = sec.querySelector('.content [class*="close"]');
	if (btn) btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); sec.classList.toggle('active'); });
});
